// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFileSvgOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 20a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zm.672-12L14 4.328V8zm-4-6a2 2 0 0 1 1.414.586l4.328 4.328A2 2 0 0 1 20 8.328V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm1.523 11.55H17c-.01.515-.056.798-.186 1.077-.287.636-.858.988-1.61.988-1.104 0-1.865-.756-1.865-1.856 0-1.118.77-1.874 1.898-1.874.747 0 1.243.31 1.573.983l-.863.358c-.158-.38-.4-.557-.752-.557-.52 0-.905.469-.905 1.095 0 .32.116.64.316.849.148.167.357.255.617.255.25 0 .46-.093.594-.26.065-.092.097-.176.125-.352h-.747zm-6.715-.886c-.223 0-.39.13-.39.302 0 .065.033.134.084.176.102.084.14.098.547.218.608.181.859.464.859.984 0 .394-.12.7-.358.905-.25.213-.607.33-1.011.33-.413 0-.84-.135-1.211-.395l.39-.733c.283.246.533.357.802.357.265 0 .441-.135.441-.339 0-.19-.12-.278-.547-.403-.39-.116-.539-.181-.664-.283-.185-.154-.278-.386-.278-.696 0-.701.482-1.179 1.188-1.179.366 0 .756.102 1.109.283l-.362.71c-.205-.162-.39-.237-.599-.237zm3.9-.672h.988l-1.49 3.498h-.71l-1.465-3.498h.992l.836 2.13z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFileSvgOutline;
